import { render, staticRenderFns } from "./StatsAudience.vue?vue&type=template&id=3871eb7f&scoped=true"
import script from "./StatsAudience.vue?vue&type=script&lang=js"
export * from "./StatsAudience.vue?vue&type=script&lang=js"
import style0 from "./StatsAudience.vue?vue&type=style&index=0&id=3871eb7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3871eb7f",
  null
  
)

export default component.exports